const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter:true,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter:true,
    },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
        sorter:true,
    },
    {
        title: 'Reject On',
        dataIndex: 'actionDate',
        sorter:true,
    },  
     
    {
        title: 'Action By',
        dataIndex: 'actionBy',
         sorter:true,
    },   
    {
        title: 'Action',
        dataIndex: 'action',
    }

];

export default columns;